import { mergeRight, pick } from '@range.io/functional'
import SampleIds from './sample-ids.js'
import { participantKeys, suspendedParticipantKeys } from './sample-participant-keys.js'
import { sampleUsers as users } from './sample-users.js'

const exampleImageUri =
    'data:image/png;base64,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'
const sampleOrganizations = {
    [SampleIds.range]: {
        createdAt: 1664405230698,
        lastUpdatedAt: 1664405230698,
        createdBy: SampleIds.jeff,
        lastUpdatedBy: SampleIds.jeff,
        name: 'Range',
        industry: 'Food/Beverage',
        // organizationSize: '1-10', make sure one organization is MISSING this optional field
        // logo: 'data:image/png;base64,...', make sure one organization is MISSING this optional field
        // icon: 'data:image/png;base64,...', make sure one organization is MISSING this optional field
        projects: [SampleIds.vanderbiltProject, SampleIds.thePreserveProject],
        participants: {
            [SampleIds.jeff]: mergeRight(pick(participantKeys, users[SampleIds.jeff]), { organizationRole: 'Admin' }),
            [SampleIds.sam]: mergeRight(pick(participantKeys, users[SampleIds.sam]), {
                organizationRole: 'Collaborator',
            }),
        },
        suspendedParticipants: {
            [SampleIds.jason]: pick(suspendedParticipantKeys, users[SampleIds.jason]),
        },
        nextProjectIdentifier: 3,

        plan: 'Enterprise',
        billingCycle: 'Annual',
        nextPaymentTimestamp: 1769932800000,
        seatCount: 10,

        // prettier-ignore
        limitsAndCounts: {
            collaborationCountLimit    : 100000,
            uploadCountLimit           : 100000,
            uploadStorageBytesLimit    : 200_000_000_000, // 200 GB,
            userAndInvitationCountLimit: 100,  // includes guests
            projectCountLimit          : 1000,
            
            collaborationCount         : 3,
            uploadCount                : 4,
            uploadStorageBytesCount    : 10_500_000, // random guess
            userAndInvitationCount     : 10,
        },
    },
    [SampleIds.tomRa]: {
        createdAt: 1664405230698,
        lastUpdatedAt: 1664405230698,
        createdBy: SampleIds.jeff,
        lastUpdatedBy: SampleIds.jeff,
        name: 'TomRa',
        industry: 'Tools',
        organizationSize: '251-1000',
        logo: exampleImageUri,
        icon: exampleImageUri,
        projects: [SampleIds.ridgedaleAveProject],
        participants: {
            [SampleIds.rafal]: mergeRight(pick(participantKeys, users[SampleIds.rafal]), { organizationRole: 'Admin' }),
            [SampleIds.tom]: mergeRight(pick(participantKeys, users[SampleIds.tom]), { organizationRole: 'Admin' }),
            [SampleIds.jeff]: mergeRight(pick(participantKeys, users[SampleIds.jeff]), { organizationRole: 'Admin' }),
            [SampleIds.greg]: mergeRight(pick(participantKeys, users[SampleIds.greg]), { organizationRole: 'Guest' }),
        },
        nextProjectIdentifier: 2,

        plan: 'Enterprise',
        billingCycle: 'Annual',
        nextPaymentTimestamp: 1769932800000,
        seatCount: 10,

        // prettier-ignore
        limitsAndCounts: {
            collaborationCountLimit    : 100000,
            uploadCountLimit           : 100000,
            uploadStorageBytesLimit    : 200_000_000_000, // 200 GB
            projectCountLimit          : 1000,
            
            userAndInvitationCountLimit: 100,  // includes guests
            
            collaborationCount         : 0,
            uploadCount                : 0,
            uploadStorageBytesCount    : 0,
            userAndInvitationCount     : 10,
        },
    },
}

export default sampleOrganizations
